import { combineReducers } from "redux";
import authReducer from "./slices/auth.slice";
import orgReducer from "./slices/org.slice";
import userReducer from "./slices/user.slice";
import dashboardReducer from "./slices/dash.slice";
import InnerCircleReducer from "./slices/inner.slice";
import CommunityReducer from "./slices/community.slice";
import ReportReducer from "./slices/report.slice";
import adminReducer from "./slices/admin.slice";
import EncouragementgroupsReducer from "./slices/encouragementgroups.slice";
import messageReducer from "./slices/message.slice";
import notificationReducer from "./slices/notification.slice";
import setingReducer from "./slices/setting.slice";
import adminInnerReducer from "./slices/adminInner.slice";
import toolsReducer from "./slices/tools.slice";
import commonReducer from "./slices/common.slice";
import departmentsReducer from "./slices/department.slice";
import directCareReducer from "./slices/directCare.slice";
import proReducer from "./slices/managePros.slice";
import createUserReducer from "./slices/createUser.slice";
import engagementFarmingReducer from "./slices/engagementFarming.slice";
import subscriptionReducer from "./slices/subscription.slice"
import referralReducer from "./slices/referralSlice.slice"

const rootReducer = combineReducers({
  authReducer,
  orgReducer,
  userReducer,
  createUserReducer,
  dashboardReducer,
  CommunityReducer,
  engagementFarmingReducer,
  ReportReducer,
  InnerCircleReducer,
  adminReducer,
  EncouragementgroupsReducer,
  messageReducer,
  notificationReducer,
  setingReducer,
  adminInnerReducer,
  toolsReducer,
  commonReducer,
  departmentsReducer,
  directCareReducer,
  proReducer,
  subscriptionReducer,
  referralReducer
});

export default rootReducer;
